module.exports = __webpack_public_path__ + "static/img/img2.06b03bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/person/img2.png
// module id = rR2P
// module chunks = 1